module.exports = __webpack_public_path__ + "static/img/pic_logn_bj.64b1fa25.png";